import { AddressCandidate } from '../../types';

interface AddressCandidatesModalProps {
  candidates: AddressCandidate[];
  onSelect: (candidate: AddressCandidate) => void;
  onContinueUnvalidated: () => void;
}

function formatCandidate(c: AddressCandidate): string {
  const lines = [...c.streetlines];
  if (c.city) lines.push(c.city);
  const stateZip = [c.state, c.postalcode].filter(Boolean).join(' ');
  if (stateZip) lines.push(stateZip);
  return lines.join(', ');
}

export function AddressCandidatesModal({
  candidates,
  onSelect,
  onContinueUnvalidated,
}: AddressCandidatesModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full mx-4 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Address Not Found</h2>
        <p className="text-sm text-gray-600 mb-4">
          The address you entered could not be verified. Did you mean one of these?
        </p>

        <ul className="space-y-2 mb-6 max-h-80 overflow-y-auto">
          {candidates.map((candidate, i) => (
            <li key={i}>
              <button
                type="button"
                onClick={() => onSelect(candidate)}
                className="w-full text-left px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-colors"
              >
                <span className="text-sm font-medium text-gray-900">{formatCandidate(candidate)}</span>
              </button>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={onContinueUnvalidated}
          className="w-full text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Continue with my original address (unvalidated)
        </button>
      </div>
    </div>
  );
}
